export default {
  ApiDomain: 'https://zinder.ml',
  MainDomain: 'https://zinder.ml',
  HomeURL: '/home',
}
